import React from 'react';

/** "I don't have any" confirmation for an empty list step (Providers,
 * Prescriptions) - same as Medicare_Intake's. Only shown while the list is
 * empty; the wizard blocks Next until the client adds something or checks it. */
export function NoneCheckbox({ checked, onChange, label }) {
  return (
    <label style={{
      display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', userSelect: 'none',
      marginTop: 16, padding: '12px 14px', background: '#f4f8fc',
      border: '1.5px solid #c5d5e8', borderRadius: 8,
    }}>
      <input
        type="checkbox"
        checked={Boolean(checked)}
        onChange={e => onChange(e.target.checked)}
        style={{ width: 17, height: 17, cursor: 'pointer', accentColor: '#1a3364', flexShrink: 0 }}
      />
      <span style={{ fontSize: 14, color: '#1a3364', fontWeight: 500 }}>{label}</span>
    </label>
  );
}

export const lbl = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  color: '#1a3364',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 5,
};

export const inp = {
  width: '100%',
  // Without this, inputs/selects inside CSS Grid columns (row2/row3, and the
  // per-step inline grids) refuse to shrink below their browser-default
  // intrinsic width, forcing 2-3 column rows wider than the screen on
  // mobile - the actual cause of fields overlapping/crowding on narrow
  // viewports rather than each column just shrinking proportionally.
  minWidth: 0,
  padding: '10px 12px',
  border: '1.5px solid #c5d5e8',
  borderRadius: 8,
  fontSize: 15,
  color: '#1a3364',
  background: '#fff',
  outline: 'none',
  display: 'block',
};

export const row2 = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 14,
  marginBottom: 18,
};

export const row3 = {
  display: 'grid',
  gridTemplateColumns: '2fr 1.5fr 2fr',
  gap: 14,
  marginBottom: 18,
};

export const smallBtn = {
  border: '1.5px solid #c5d5e8',
  background: '#fff',
  color: '#1a3364',
  borderRadius: 8,
  padding: '8px 12px',
  fontWeight: 800,
  cursor: 'pointer',
};

export function noAutofill(name) {
  return {
    name: `indfam-${name}`,
    autoComplete: 'new-password',
    autoCorrect: 'off',
    spellCheck: false,
  };
}

export function formatPhone(val) {
  const digits = String(val || '').replace(/\D/g, '').slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function parseHeight(value) {
  const raw = String(value || '').trim();
  const oldFormat = raw.match(/^(\d+)'(\d+)"?$/);
  if (oldFormat) return { feet: oldFormat[1], inches: oldFormat[2] };
  const total = Number.parseInt(raw, 10);
  if (Number.isFinite(total) && total > 0) {
    return { feet: String(Math.floor(total / 12)), inches: String(total % 12) };
  }
  return { feet: '', inches: '' };
}

export function formatHeight(value) {
  const { feet, inches } = parseHeight(value);
  return feet ? `${feet} ft ${inches || 0} in` : '';
}

export function heightToInches(feet, inches) {
  if (!feet) return '';
  return String((Number(feet) * 12) + Number(inches || 0));
}
